import Cookies from "js-cookie";
import React, { useState } from "react";
import { Button, Col, Form, Row, Spinner, Toast, ToastContainer } from "react-bootstrap";
import packageJson from '../../../../../../package.json';
import { AccountStrings, IFormSignupComponent } from "../../../business/core";
import { FormRecoveryControllerImpl } from "../../../business/impl";

export const FormRecoveryCodeValidateComponent: React.FC<IFormSignupComponent> = ({ setStep, setData, formData }) => {
    const [validated, setValidated] = useState(false);
    const [code, setCode] = useState<string>();
    const [codeError, setCodeError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [toastingText, setToastingText] = useState(null);
    const version = packageJson.version;

    const controller = new FormRecoveryControllerImpl();

    const translate = AccountStrings['PTBR'];
    const resendData = async () => {
        if (!formData) return false;
        setIsLoading(true);
        try {
            const response = await controller.requestRecoveryAccess(formData);

            if (response === 'success') {
                setIsLoading(false);
                setStep(3)
                return true;
            }
            if (response)
                setToastingText(translate.recovery.errors[response]);
        } catch (error) {
            setToastingText(error.message);
        }
        window.scrollTo(0, 0);
        setIsLoading(false);
    }

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        setValidated(true);
        setCodeError(false);

        if (!code || code === "" || code.length !== 6) {
            setValidated(false);
            setCodeError(true);
            setIsLoading(false);
            return false;
        }
        if (!formData) return false;
        formData.delete("code");
        formData.append("code", code);

        if (form.checkValidity() === false) {
        } else {
            setIsLoading(true);
            try {
                const response = await controller.recoveryCodeValidate(formData);
                if (response.success === true && response.response) {
                    Cookies.set("jwtToken", response.response, { secure: true, expires: 7 });
                    setStep(3)
                    return true;
                }
                setCodeError(true);
            } catch (error) {
                setToastingText(translate.recovery.errors[error.message]);
            }
            window.scrollTo(0, 0);
            setIsLoading(false);
        }
    };

    return (
        <>
            <p>{translate.signup.codeTitle}</p>
            <Form className="mt-4" onSubmit={handleSubmit} validated={validated}>
                <Form.Group className="mb-3" controlId="formCode">
                    <Form.Control
                        required
                        placeholder={translate.signup.placeholder.code}
                        onChange={(e) => setCode(e.target.value)}
                        className="custom-input text-capitalize"
                        disabled={isLoading}
                        isInvalid={codeError}
                        autoFocus
                        autoComplete="off"
                        maxLength={6}
                    />
                    <Form.Control.Feedback type="invalid">
                        {codeError ? translate.signup.feedback.code : ""}
                    </Form.Control.Feedback>
                </Form.Group>
                <fieldset disabled={isLoading}>
                    <div className="row">
                        <div className="col-12 mb-3">
                            <a href={"#"} onClick={resendData} style={{ textDecoration: 'none', color: '#333333' }}>{translate.signup.resendCodeText}</a>
                        </div>
                        <div className="col">
                            <Button
                                variant="primary"
                                type="button"
                                className="px-4 button-flat"
                                onClick={() => setStep(1)}
                                disabled={isLoading}
                            >
                                {!isLoading ? (
                                    translate.signup.back_button
                                ) : (
                                    <Spinner animation="border" size="sm" role="status">
                                        <span className="visually-hidden">...</span>
                                    </Spinner>
                                )}
                            </Button>
                        </div>
                        <div className="col d-flex flex-row-reverse">
                            <Button
                                variant="primary"
                                type="submit"
                                className="px-4 button-flat"
                                disabled={isLoading}
                            >
                                {!isLoading ? (
                                    translate.recovery.requestRecoveryButton
                                ) : (
                                    <Spinner animation="border" size="sm" role="status">
                                        <span className="visually-hidden">...</span>
                                    </Spinner>
                                )}
                            </Button>
                        </div>
                    </div>
                    <Row>
                        <Col className="text-center mt-2"><small style={{ color: '#999999' }}>v{version}</small></Col>
                    </Row>
                </fieldset>
            </Form>
            <ToastContainer position="top-end">
                <Toast
                    bg={"danger"}
                    onClose={() => setToastingText(null)}
                    show={toastingText !== null ? true : false}
                    delay={5000}
                    autohide
                >
                    <Toast.Body className={"text-white"}>
                        {toastingText !== null ? toastingText : null}
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </>
    );
};
